import { GetInvestorValuationsRes, SecurityType } from '@dealstack/shared/lib/generated';
import { HoldingsTableRow } from './types';

const LOAN_ROW_PREFIX = '__loans__';

export function buildRows(data: GetInvestorValuationsRes[]): HoldingsTableRow[] {
	const rows: HoldingsTableRow[] = [];

	for (const investor of data) {
		const investorContext = {
			_investorId: investor.investorId,
			currency: investor.currency,
			entityName: investor.entityName,
			programmeName: investor.programmeName,
			targetName: investor.targetName,
		};

		for (const v of investor.valuations) {
			rows.push({ ...v, ...investorContext });
		}

		if (investor.loans.length > 0) {
			rows.push({
				securityId: `${LOAN_ROW_PREFIX}${investor.investorId}`,
				name: '',
				volume: 0,
				cost: 0,
				securityCurrency: investor.currency,
				securityUnitDenominator: 1,
				isSubjectToVesting: false,
				type: investor.valuations[0]?.type ?? SecurityType.ORDINARY_SHARE,
				...investorContext,
				_loans: investor.loans,
			});
		}
	}

	return rows;
}
